/*
 * Galería de producto reforzada para Shrine/Dawn.
 * El manejador global funciona incluso si otro script registró <media-gallery>
 * antes de que este archivo se cargara.
 */
(function () {
  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function activateMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
      return;
    }

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var media = viewer && viewer.querySelector(
      '[data-media-id="' + escapeSelector(mediaId) + '"]'
    );
    if (!viewer || !media) return;

    viewer.querySelectorAll('[data-media-id]').forEach(function (item) {
      item.classList.toggle('is-active', item === media);
    });

    var slider = viewer.slider || viewer.querySelector('[id^="Slider-Gallery"]');
    if (slider && typeof slider.scrollTo === 'function') {
      slider.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
    } else {
      media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    gallery.querySelectorAll('.thumbnail[aria-current="true"]').forEach(function (item) {
      item.removeAttribute('aria-current');
    });
    var activeButton = gallery.querySelector(
      '.thumbnail[data-media-target="' + escapeSelector(mediaId) + '"]'
    );
    if (activeButton) activeButton.setAttribute('aria-current', 'true');

    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    var deferred = media.querySelector('.deferred-media');
    if (deferred && typeof deferred.loadContent === 'function') {
      deferred.loadContent(false);
    }
  }

  /* Captura el clic antes que los controles del slider puedan detenerlo. */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest &&
        event.target.closest('media-gallery .thumbnail[data-media-target]');
      if (!button) return;

      var gallery = button.closest('media-gallery');
      event.preventDefault();
      event.stopPropagation();
      activateMedia(gallery, button.getAttribute('data-media-target'));
    },
    true
  );

  if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          };
          this.mql = window.matchMedia('(min-width: 750px)');
          this.productInfo = document.getElementById('ProductInfo-' + this.dataset.section);

          if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
          if (!this.elements.viewer) return;

          this.elements.viewer.addEventListener(
            'slideChanged',
            this.onSlideChanged.bind(this)
          );

          if (
            this.dataset.desktopLayout &&
            this.dataset.desktopLayout.includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        onSlideChanged(event) {
          var current = event.detail && event.detail.currentElement;
          if (!current || !this.elements.thumbnails) return;
          this.setActiveThumbnail(
            this.elements.thumbnails.querySelector(
              '[data-target="' + escapeSelector(current.dataset.mediaId) + '"]'
            )
          );
        }

        setActiveMedia(mediaId, prepend) {
          var activeMedia = this.elements.viewer.querySelector(
            '[data-media-id="' + escapeSelector(mediaId) + '"]'
          );
          if (!activeMedia) return;

          this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function (item) {
            item.classList.toggle('is-active', item === activeMedia);
          });

          if (prepend) {
            activeMedia.parentElement.prepend(activeMedia);
            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();
          var slider = this.elements.viewer.slider ||
            this.elements.viewer.querySelector('[id^="Slider-Gallery"]');

          window.setTimeout(function () {
            if (slider && typeof slider.scrollTo === 'function') {
              slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            } else {
              activeMedia.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start',
              });
            }
          }, 0);

          this.playActiveMedia(activeMedia);
          if (!this.elements.thumbnails) return;
          this.setActiveThumbnail(
            this.elements.thumbnails.querySelector(
              '[data-target="' + escapeSelector(mediaId) + '"]'
            )
          );
        }

        setActiveThumbnail(thumbnail) {
          if (!thumbnail || !this.elements.thumbnails) return;
          this.elements.thumbnails.querySelectorAll('.thumbnail').forEach(function (button) {
            button.removeAttribute('aria-current');
          });
          var button = thumbnail.querySelector('.thumbnail');
          if (button) button.setAttribute('aria-current', 'true');
        }

        playActiveMedia(activeItem) {
          if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
          var deferred = activeItem.querySelector('.deferred-media');
          if (deferred && typeof deferred.loadContent === 'function') {
            deferred.loadContent(false);
          }
        }

        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (this.stickyHeader) {
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
          }
        }

        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach(function (slide) {
            slide.setAttribute('role', 'presentation');
          });
        }
      }
    );
  }
})();
